import { render, staticRenderFns } from "./ForgotToAddCartMenuItem.vue?vue&type=template&id=214ee207&scoped=true"
import script from "./ForgotToAddCartMenuItem.vue?vue&type=script&lang=js"
export * from "./ForgotToAddCartMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ForgotToAddCartMenuItem.vue?vue&type=style&index=0&id=214ee207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ee207",
  null
  
)

export default component.exports